import React from "react";
import {
  AppName,
  BusinessInfo,
  BusinessName,
  HeaderContainer,
  Logo,
  LogoLink,
} from "./styles";
import logo from "../../assets/logo.png";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

interface KLHeaderProps {
  businessId?: string | null;
}

const KLHeader: React.FC<KLHeaderProps> = ({ businessId }) => {
  const { business } = useSelector((state: RootState) => state.customers);

  return (
    <HeaderContainer>
      {businessId ? (
        <BusinessInfo>
          <BusinessName>{business?.businessName}</BusinessName>
        </BusinessInfo>
      ) : (
        <LogoLink to="/">
          <Logo src={logo} alt="Company Logo" />
          <AppName>kavanu.li</AppName>
        </LogoLink>
      )}
    </HeaderContainer>
  );
};

export default KLHeader;
